import React, { useState, useEffect, useRef } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { animateScroll as scroll } from 'react-scroll';
import '../css/font.css';
const TopMenuMobile = (props) => {
  const [searchView, setSearchView] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [originText, setOriginText] = useState('');
  const [showAutoKeyword, setShowAutoKeyword] = useState(false);
  const [keywordList, setKeywordList] = useState([]);
  const [selectIndex, setSelectIndex] = useState(-1);
  const [ic, setIc] = useState('');

  const {
    apiUrl,
    history,
    loginId,
    nicName,
    icon,
    setTvline,
    setLoginId,
    setAuthId,
    setIcon,
    pkg,
  } = props;
  const search = useRef();
  const _goHome = () => {
    history.push('/');
  };

  const _goVod = () => {
    history.push('/list');
  };

  const _goShop = () => {
    window.open('https://shop.aniplustv.com');
  };
  const _goStore = () => {
    history.push('/store');
  };
  const _ticket = () => {
    history.push('/ticket');
  };
  const _event = () => {
    history.push('/event');
  };
  const _customer = () => {
    history.push('/customer/1');
  };
  const _onTvTime = () => {
    //setTimeline(false);
    setTvline(true);
  };
  const _goLogin = () => {
    window.scrollTo(0, 0);
    history.push('/login');
  };
  const _onSearchChange = (e) => {
    //const { searchText } = this.state;
    //console.log(e.target.value)
    setSearchText(e.target.value);
    _autoKeyword(e.target.value);
  };
  const _autoKeyword = async (strFind) => {
    const result = await axios(apiUrl + '/autoKeyword?strFind=' + strFind);

    const intReturn = result.data[0].intReturn;
    if (intReturn === 0) {
      console.log(result.data[0].listData);
      setKeywordList(result.data[0].listData);
      setShowAutoKeyword(true);
    } else {
      setKeywordList([]);
      setShowAutoKeyword(true);
    }
  };
  const _selectItem = (title) => {
    setSearchText(title);
    setOriginText(title);
    setShowAutoKeyword(false);

    search.current.focus();
  };
  const _onKeyup = (e) => {
    const key = e.keyCode;
    const keyLength = keywordList ? keywordList.length : 0;
    if (key === 13) {
      if (searchText) {
        let g = 'n';
        if (originText === searchText) {
          g = 'y';
        }
        history.push('/search?st=' + searchText + '&g=' + g);
        setSearchText('');
        setOriginText('');
        setShowAutoKeyword(false);
        setSelectIndex(-1);
      }
    } else if (key === 38) {
      if (selectIndex > 0) {
        setSelectIndex(selectIndex - 1);
        setSearchText(keywordList[selectIndex - 1].title);
        setOriginText(keywordList[selectIndex - 1].title);
      }
    } else if (key === 40) {
      if (keyLength >= selectIndex + 2) {
        setSelectIndex(selectIndex + 1);
        setSearchText(keywordList[selectIndex + 1].title);
        setOriginText(keywordList[selectIndex + 1].title);
      }
    }
  };
  const _my = () => {
    history.push('mypage/0');
  };
  const _onLogout = () => {
    // const { setLoginId, setAuthId, history, showTimeline } = props;
    setTvline(false);
    // this.setState({
    //   showTimeline: false,
    // });
    setCookie('account', '');
    setCookie('ad', '');
    setCookie('at', '');
    setCookie('rt', '');
    setCookie('ni', '');
    setCookie('ic', '');

    setLoginId('');
    setAuthId('');

    localStorage.removeItem('at');
    localStorage.removeItem('rt');

    toast.success('정상적으로 로그아웃 되었습니다.');

    history.push('/');
  };
  const setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }

    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/;domain=aniplustv.com';
  };
  const getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');

    return value ? value[2] : null;
  };
  const _getIcon = async () => {
    // const at = localStorage.getItem('at');
    const at = getCookie('at');
    try {
      const result = await axios.post(
        apiUrl + '/my_pkg',
        {
          params: {
            userid: loginId,
            pkg: pkg,
          },
        },
        {
          headers: {
            Authorization: 'bearer ' + at,
          },
        }
      );

      const intReturn = result.data[0].intReturn;
      if (intReturn === 0) {
        setIc(result.data[0].listData[0].myCharImg);
        setIcon(result.data[0].listData[0].myCharImg);
      }
    } catch (error) {
      if (error.response.status === 403) {
        _refreshToken();
      }
    }
  };
  const _refreshToken = async () => {
    // const rt = localStorage.getItem('rt');
    const rt = getCookie('rt');
    if (rt === '' || rt === undefined || rt === null) {
      history.push('/login');
      return false;
    }

    const { data } = await axios.post(apiUrl + '/refreshToken', {
      params: {
        rt: rt,
        userid: loginId,
      },
    });

    if (data[0].intReturn === 0) {
      //console.log(data[0].at)
      // localStorage.setItem('at', data[0].at);
      setCookie('at', data[0].at);
      _getIcon();
    } else {
      this.setCookie('account', '');

      setLoginId('');
      setAuthId('');

      setTimeout(() => {
        history.push('/login');
      }, 500);
    }
  };
  useEffect(() => {
    if (loginId) {
      _getIcon();
    }
  }, [loginId]);
  return (
    <div className={'header header_fixed'}>
      <h1 className="logo" alt="로고" onClick={_goHome}></h1>

      <div className="gnb">
        <ul>
          <li>
            <button
              type="button"
              className="btn_srch"
              onClick={() => setSearchView(true)}
            >
              검색
            </button>

            {searchView ? (
              <div className="top_search">
                <div
                  className={
                    history.location.pathname.indexOf('/store') > -1 ||
                    history.location.pathname.indexOf('/story') > -1
                      ? 'top_search search_input'
                      : 'search_input input_on'
                  }
                >
                  <input
                    ref={search}
                    type="text"
                    placeholder="[초성검색] 작품, 감독, 제작사명을 입력해 주세요"
                    className="common_input input_style1 "
                    value={searchText}
                    onChange={_onSearchChange}
                    onKeyUp={_onKeyup}
                  />
                  <span
                    style={{ cursor: 'pointer' }}
                    onClick={() => setSearchView(false)}
                  >
                    삭제
                  </span>
                </div>
                {showAutoKeyword ? (
                  keywordList.length > 0 ? (
                    <div className="search_text">
                      {keywordList.map((item, index) => (
                        <p
                          key={item.contentSerial}
                          onClick={() => _selectItem(item.title)}
                          style={
                            selectIndex === index
                              ? { color: 'red', fontWeight: 900 }
                              : null
                          }
                        >
                          {item.title}
                        </p>
                      ))}

                      {/* {keywordList ? _renderKeywordItem : null} */}
                    </div>
                  ) : null
                ) : null}
              </div>
            ) : null}
          </li>

          {loginId === '' || loginId === undefined || loginId === null ? (
            <li>
              <a
                onClick={_goLogin}
                className="gnb_link user"
                style={{
                  cursor: 'pointer',
                  color:
                    history.location.pathname.indexOf('/store') > -1 ||
                    history.location.pathname.indexOf('/story') > -1
                      ? null
                      : '#fff',
                }}
              >
                로그인
              </a>
            </li>
          ) : (
            <li>
              <button
                type="button"
                className="gnb_link"
                title="마이페이지"
                onClick={_my}
                style={{
                  color:
                    history.location.pathname.indexOf('/store') > -1 ||
                    history.location.pathname.indexOf('/story') > -1
                      ? null
                      : '#fff',
                }}
              >
                <img src={icon} className="char-icon" />
              </button>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default shopContext(withRouter(TopMenuMobile));
